import React from 'react';
import { fetchNavHTML } from '~/libs/server/nav';
import { fetchUser } from '~/libs/server/users';
import { GetServerSideProps } from 'next';
import IncomingMessageWithCookies from '~/types/IncomingMessageWithCookies';

import WebsiteLP from '~/components/WebsiteLp';
import { WebsiteLpProps } from '~/components/WebsiteLp/WebsiteLp';
import { fetchSEORelatedLinks } from '~/libs/server/seo';

const WebsiteV3LPContainer: React.FC<WebsiteLpProps> = (props): JSX.Element => {
  return <WebsiteLP {...props} />;
};

export default WebsiteV3LPContainer;

export const getServerSideProps: GetServerSideProps<WebsiteLpProps> = async ({
  req,
}: {
  req: IncomingMessageWithCookies;
}) => {
  const [navHTML, userCtx, adviceLinks] = await Promise.all([
    fetchNavHTML(req),
    fetchUser(req),
    fetchSEORelatedLinks({
      topicSlug: 'wedding-planning-101',
      subtopicSlug: 'wedding-websites',
    }),
  ]);

  // Redirect post-auth users to edit website
  if (userCtx && !userCtx.is_guest) {
    return {
      redirect: {
        destination: '/wedding/manage/website/customize',
        permanent: false,
      },
    };
  }

  return {
    props: {
      navHTML,
      userCtx,
      adviceLinks,
    },
  };
};
